import styled from "styled-components"
import { CardActions } from "@material-ui/core"

const CardActionsFooter = styled(CardActions)`
  position: absolute;
  bottom: 1rem;
`
export default CardActionsFooter
